/**********************************************************************
 * Name: balance.js
 * Author: Hoa Tang
 * Date: December 20, 2016
 *
 * Description:
 *********************************************************************/

var balance = angular.module('balance', []);